<div class="uk-position-relative">
    <div style="margin-left: 20px; margin-top: -20px;" class="uk-position-absolute">
        <a uk-slidenav-previous></a>
        <a class="uk-link-muted uk-text-uppercase uk-link-toggle" [routerLink]="['/user/list']">
            <span class="uk-link-heading">Liste des utilisateurs</span>
        </a>
    </div>

    <div class="uk-margin-medium-top tab">
        <ul class="uk-flex-center" uk-tab>
            <li [class.uk-active]="menu.active.tab === 'information'">
                <a [routerLink]="['/user/informations', id]">Informations</a>
            </li>
        </ul>
    </div>
</div>